// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#222","menuActiveText":"#163DC9","subMenuActiveText":"#163DC9","menuBg":"#FFF","menuHover":"#E7EBF9","subMenuBg":"#FFF","subMenuHover":"#E7EBF9","sideBarWidth":"230px"};